import { useTranslation } from "react-i18next";
import FieldHelpLink from "../../ui/forms/FieldHelpLink";
import { HELP_ARTICLES, type HelpArticleId } from "./helpArticles";
import { useHelpOpener } from "./opening/helpOpening";

/** A field's link to its article, with the question the article answers (WA-6). */
export default function HelpArticleLink({ article }: { article: HelpArticleId }) {
  const { t } = useTranslation();
  const { linkProps } = useHelpOpener();
  return <FieldHelpLink {...linkProps(HELP_ARTICLES[article])}>{t(`help.articles.${article}.question`)}</FieldHelpLink>;
}
